module.exports = __webpack_public_path__ + "static/img/logo.1ecedc83.png";